module.exports = __webpack_public_path__ + "static/media/cfv.4bf5753a.jpg";